import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

import { faMapPin } from "@fortawesome/free-solid-svg-icons";

import axios from "axios";

const services = [
  "Mobile Service Calls", // Most important
  "Winterizing & De-winterizing",
  "Roof Resealing & Leak Repairs",
  "Plumbing & Water System Repairs",
  "Electrical Diagnostics & Repairs",
  "Brake Inspections & Bearing Repacks",
  "Shop Based Repairs",
  "Awning & Slide Topper Install",
  "Pre-purchase Inspections",
  "General Maintenance",
  "Annual Checkups",
  "Select Towing Services",
  "… and much more!",
];



function Home() {

  const [featuredGallery, setFeaturedGallery] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/gallery/featured/`)
    //axios.get("http://127.0.0.1:8000/api/gallery/featured/")
      .then(res => setFeaturedGallery(res.data))
      .catch(err => console.error("Error fetching featured gallery images:", err));
  }, []);

  return (
    <div className="bg-gray-50 text-gray-800">
      
      
      
      
      
      {/* Hero Section */}
      <section
        className="bg-cover bg-center text-white text-center py-24 px-4"
        style={{
          backgroundImage: 'url("/header2.jpeg")',
        }}
      >
        <div className="bg-black bg-opacity-40 p-8 rounded max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4">
            Jake’s RV Repair & Maintenance
          </h1>
          <p className="text-lg sm:text-xl mb-6">
            Trusted mobile and shop services across Vancouver Island.
          </p>
          <Link
            to="/contact"
            className="bg-neutral text-black font-semibold px-6 py-3 rounded shadow hover:bg-primary transition"
          >
            Contact Us Today
          </Link>
        </div>
      </section>
      
      {/* Our Coverage */}
      <section className="bg-white py-12 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">Our Coverage</h2>
          <ul className="flex flex-col sm:flex-row justify-center gap-12 max-w-4xl mx-auto text-black">
            {["South Cowichan", "North Cowichan", "Malahat", "Sahtlam", "Lake Cowichan"].map((area, index) => (
              <li key={index} className="flex items-center space-x-2">
                <FontAwesomeIcon icon={faMapPin} className="text-blue-600" />
                <span>{area}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>


      {/* Our Services */}
      <section className="bg-white py-12 px-6">
        <h2 className="text-3xl font-bold text-center mb-8">Our Services</h2>

        {/* Centered Columns in Flex */}
        <div className="flex flex-col sm:flex-row justify-center gap-2 sm:gap-12 max-w-4xl mx-auto text-black">
          {/* Column 1 */}
          <div className="space-y-2">
            {services.slice(0, 6).map((service, index) => (
              <div key={index} className="flex items-start space-x-3">
                <FontAwesomeIcon icon={faCircleCheck} className="text-blue-600 mt-1" />
                <span>{service}</span>
              </div>
            ))}
          </div>
          {/* Column 2 */}
          <div className="space-y-2">
            {services.slice(6, 12).map((service, index) => (
              <div key={index + 6} className="flex items-start space-x-3">
                <FontAwesomeIcon icon={faCircleCheck} className="text-blue-600 mt-1" />
                <span>{service}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Centered "... and much more!" */}
        <div className="text-center mt-6">
          <div className="inline-flex items-center space-x-2 text-black font-semibold">
            <span>… and much more!</span>
          </div>
        </div>
      </section>


      


      {/* Gallery Preview */}
      {/* */}
      <section className="max-w-6xl mx-auto py-12 px-6">
        <h2 className="text-3xl font-bold text-center mb-8">Our Work</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {featuredGallery.length === 0 ? (
            <p className="col-span-full text-center text-gray-500">No featured gallery images yet.</p>
          ) : (
            featuredGallery.slice(0, 3).map(image => (
              <Link
                to="/gallery"
                key={image.id}
                className="rounded shadow overflow-hidden hover:opacity-90 transition duration-200"
              >
                <img
                  src={image.image}
                  alt={image.title || "Gallery Image"}
                  className="w-full h-48 object-cover"
                />
              </Link>
            ))
          )}
        </div>
        <div className="text-center mt-6">
          <Link to="/gallery" className="text-black hover:underline font-medium">View Full Gallery →</Link>
        </div>
      </section>
      

      {/* Final CTA */}
      <section className="bg-black py-12 text-center px-6">
        <h2 className="text-2xl text-white font-bold mb-4">Ready to Get Back on the Road?</h2>
        <p className="text-white mb-6">Contact us now to schedule a repair or get a quote on your next service.</p>
        <Link to="/contact" className="bg-white text-black px-6 py-3 rounded hover:bg-primary transition">
          Book Now
        </Link>
      </section>
    </div>
  );
}

export default Home;
